module.exports = __webpack_public_path__ + "media/images/trianglify-0cb78e0bd2fec521e73b2ad5bbc779a1.png";